// 47284: which refresh-job outputs each shell route DISPLAYS (module/section[/tab]) -> the shell page header shows ONE shared
// freshness chip for them (components/RefreshVerdictChip). Source of truth for "where is this job's output read": the Data
// Refreshes "Read by" list (pages/DataRefreshesPage READERS) + the API readers. Routes that already carry the Refresh data button
// (RefreshDataButton shows the chip itself) are NOT listed: forecast/*, alerts/overview, alerts/charts, inventory/forecast,
// inventory/price-analysis; and farm-ops/benchmarks (its Updated stamp + Refresh curves control carry the chip between them, 47284c). Skipped as incidental: Alerts nav badge (the Alerts page chip covers it), Reports > Inventory Valuation
// (inventory_valuation_reconcile is a user-driven stub, not a scheduled job), Sales > Customers directory beyond the credit column.
export const ROUTE_REFRESH_JOBS = {
  'home/today': 'mv_alerts',
  'farm-ops/bands': 'mv_alerts,alert_ledger,mv_band_week_economics,band_milestone,benchmark_historicals,combo_curves',
  'farm-ops/activities': 'activity_engine',
  'reports/analytics/farm-activity': 'activity_engine',
  'sales/customers/directory': 'credit_alert',
  'finance/general-ledger': 'gj_clean_state,sanity_report',
  'control-admin/sanity': 'sanity_report,gj_clean_state',
  'control-admin/data-health': 'data_health',
  'control-admin/finance-settings/period-lock': 'gj_clean_state',
  'control-admin/engines/e8': 'band_forecast',
  'control-admin/engines/e9': 'mv_alerts',
  'control-admin/engines/e11': 'finance_reconcile',
  'control-admin/supporting-engines': 'mv_band_week_economics',
  'control-admin/supporting-engines/evaluation-ledger': 'alert_ledger',
  'control-admin/supporting-engines/mv_item_price': 'mv_item_price',
};
export function refreshJobsFor(moduleKey, sectionKey, tabKey) {
  return ROUTE_REFRESH_JOBS[`${moduleKey}/${sectionKey}/${tabKey}`] || ROUTE_REFRESH_JOBS[`${moduleKey}/${sectionKey}`] || null;
}
